export default {
  methods: {
    handlePickerKeydown (event) {
      if (!this.picker) {
        this.mountPicker();
      }
      const keyCode = event.keyCode;

      // ESC
      if (keyCode === 27) {
        this.pickerVisible = false;
        event.stopPropagation();
        return;
      }

      // Tab
      if (keyCode === 9) {
        if (!this.ranged) {
          this.handleChange();
          if (this.type !== 'datetime') {
            this.pickerVisible = this.picker.visible = false;
          }
          this.blur();
          // 自定义日期范围组件失焦
          if (this.$parent && this.$parent.$parent) {
            this.$parent.$parent.focusBool = false;
          }
          event.stopPropagation();
        } else {
          // user may change focus between two input
          setTimeout(() => {
            if (this.refInput.indexOf(document.activeElement) === -1) {
              this.pickerVisible = false;
              this.blur();
              event.stopPropagation();
            }
          }, 0);
        }
        return;
      }

      // Enter
      if (keyCode === 13) {
        if (this.userInput === '' || !this.userInput || this.isValidValue(this.parseString(this.displayValue))) {
          this.handleChange();
          if (this.type !== 'datetime') {
            this.pickerVisible = !this.picker.visible;
          } else {
            this.pickerVisible = true;
          }
          if (!this.ranged) {
            let validType = ['date', 'year', 'month', 'week', 'datetime'].includes(this.type);
            if (this.type === 'time') {
              this.picker.value = this.picker.date;
            } else if (this.type === 'time-select') {
              this.picker.keyboardValue = this.picker.value;
            } else if (validType) {
              if (this.type === 'datetime') {
                this.picker && this.picker.handleDatetimeKeydown(event);
                this.picker.timePickerVisible = false;
              }
              this.picker.value = this.picker.keyboardDate;
            }
          } else {
            this.picker.value = [this.picker.minDate, this.picker.maxDate];
          }
          if (!this.pickerVisible) {
            this.emitInput(this.picker.value);
          }
        }
        event.stopPropagation();
        return;
      }

      // if user is typing, do not let picker handle key input
      if (this.userInput) {
        event.stopPropagation();
        return;
      }

      if (keyCode === 37 || keyCode === 38 || keyCode === 39 || keyCode === 40) {
        this.pickerVisible = true;
        event.stopPropagation();
      }

      // delegate other keys to panel
      if (this.picker && this.picker.handleKeydown) {
        this.picker.handleKeydown(event);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./~/vue-xpc/src/element-ui/packages/date-picker/keydown.js